import { ComponentPropsWithRef } from "react";
import styled from "styled-components";

// TEXT

// STYLES
export const Icon = styled.svg<{ $small?: boolean }>`
  width: ${({ $small }) => ($small ? "1rem" : "1.25rem")};
`;

// DATA

// TYPES
export interface Props extends ComponentPropsWithRef<"svg"> {
  $small?: boolean;
}

// CONSTANTS

// FUNCTIONS

// ASSETS
